"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsingText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var react_1 = __importStar(require("react"));
var CollapsingText = function (props) {
    var className = props.className, lineClampLength = props.lineClampLength, clampIndicator = props.clampIndicator;
    var _a = (0, react_1.useState)(true), isClamped = _a[0], setIsClamped = _a[1];
    var cls = (0, BootstrapHelper_1.B)().add(isClamped ? "collapsing-text__clamped" : "collapsing-text__unclamped").bem;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: { lineClamp: lineClampLength, WebkitLineClamp: lineClampLength }, className: "".concat(cls, " ").concat(className || ""), onClick: function () { return setIsClamped(!isClamped); } }, { children: props.children })), clampIndicator &&
                react_1.default.cloneElement(clampIndicator, { isClamped: isClamped, setIsClamped: setIsClamped })] }));
};
exports.CollapsingText = CollapsingText;
